module.exports = __webpack_public_path__ + "static/media/comment-white-oval-bubble.7adcd6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comment-white-oval-bubble.png
// module id = 34
// module chunks = 0